// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"6":"token","50":"match","83":"train","229":"config","966":"login"}[chunkId] + "." + {"6":"9c4127f7","50":"962bf42d","83":"2dd5b9af","229":"e68dd5dc","966":"e68b9841"}[chunkId] + ".css";
};